import { render, staticRenderFns } from "./workerJobTitleQueueWarning.vue?vue&type=template&id=04968e00&"
import script from "./workerJobTitleQueueWarning.vue?vue&type=script&lang=js&"
export * from "./workerJobTitleQueueWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports